/** Minimum file size (1KB) - sanity check for corrupted/empty files */
export const MIN_FILE_SIZE_BYTES = 1024;

/** Maximum size of a single uploaded file — the API multipart limit. */
export const MAX_UPLOAD_FILE_SIZE_BYTES = 10 * 1024 * 1024;

/** Maximum file size for work accident / medical leave admin documents (~10 PDF pages). */
export const MAX_WORK_ACCIDENT_DOCUMENT_FILE_SIZE_BYTES = 5 * 1024 * 1024;

export const getUploadFileSizeError = (fileSizeBytes: number): string | undefined => {
  if (fileSizeBytes < MIN_FILE_SIZE_BYTES) {
    return "Le fichier est trop petit et ne semble pas être un document valide.";
  }

  if (fileSizeBytes > MAX_UPLOAD_FILE_SIZE_BYTES) {
    return "Le fichier dépasse la taille maximale autorisée (10 Mo).";
  }

  return undefined;
};

export const getWorkAccidentDocumentFileSizeError = (fileSizeBytes: number): string | undefined => {
  if (fileSizeBytes < MIN_FILE_SIZE_BYTES) {
    return "Le fichier est trop petit et ne semble pas être un document valide.";
  }

  if (fileSizeBytes > MAX_WORK_ACCIDENT_DOCUMENT_FILE_SIZE_BYTES) {
    return "Le fichier dépasse la taille maximale autorisée (5 Mo). Environ 10 pages maximum.";
  }

  return undefined;
};

// The carte BTP photo: a front-facing picture, in a format the card's portal takes.
export const PROFESSIONAL_CARD_PHOTO_MIMETYPES = ["image/jpeg", "image/png"];
